import React from "react";
import OutsideOrgNewUserContent from "../components/users/outside-org-new-user-content";

const OutsideOrgNewUser = () => {
  return <OutsideOrgNewUserContent />;
};

export default OutsideOrgNewUser;
